const DashboardKeys = {
  EHBL_MANIFEST_TITLE: "ehblManifestTitle",
  EHBL_MANIFEST_BY_SUBMITTED_DATE_TITLE: "ehblManifestBySubmittedDateTitle",
  PRIMARY_CCN: "primaryCCN",
  STATUS: "status",
  PORT_OF_DISCHARGE: "portOfDischarge",
  PORT_OF_DESTINATION_EXIT: "portOfDestinationExit",
  HBL_STATUS_RELEASED: "hblStatusReleased",
  MASTER_REFERENCE_NUMBER: "masterReferenceNumber",
  DRAFT: "draft",
  ACCEPTED: "accepted",
  SENT: "sent",
  REJECTED: "rejected",
  STATUS_NOTIFICATION: "statusNotification",
  CANCELLATION_ACCEPTED: "cancellationAccepted",
  CANCELLATION_REJECTED: "cancellationRejected",
  MODIFICATION_REJECTED: "modificationRejected",
  REPLACE_REJECTED: "replaceRejected",
  ISF10_TITLE: "isf10Title",
  ISF10_BY_SUBMITTED_DATE_TITLE: "isf10BySubmittedDateTitle",
  TRANSACTION_ID: "transactionId",
  IMPORTER_DOCUMENT_NUMBER: "importerDocumentNumber",
  SHIPMENT_REFERENCE_NUMBER: "shipmentReferenceNumber",
  REFERENCE_BOOKING_NUMBER: "referenceBookingNumber",
  SEE_ALL_RECORDS: "seeAllRecords",
  ACEOCEAN_TITLE: "aceOceanTitle",
  ACEOCEAN_BY_SUBMITTED_DATE_TITLE: "aceOceanBySubmittedDateTitle",
  SCAC: "scac",
  ETA: "eta",
  VESSEL_NAME: "vesselName",
  VOYAGE_NUMBER: "voyageNumber",
  PORT: "port",
  SEE_ALL_MANIFESTS: "seeAllManifests",
  FDAPN_TITLE: "fdapnTitle",
  FDAPN_BY_SUBMITTED_DATE_TITLE: "fdapnBySubmittedDateTitle",
  REFERENCE_NUMBER: "referenceNumber",
  ENTRY_TYPE: "entryType",
  BILL_TYPE: "billType",
  ARRIVAL_LOCATION: "arrivalLocation",
  ANTICIPATED_ARRIVAL_DATE: "anticipatedArrivalDate",
  ENTRY_TYPE_01: "entryType01",
  ENTRY_TYPE_02: "entryType02",
  ENTRY_TYPE_03: "entryType03",
  ENTRY_TYPE_07: "entryType07",
  ENTRY_TYPE_11: "entryType11",
  ENTRY_TYPE_12: "entryType12",
  ENTRY_TYPE_21: "entryType21",
  ENTRY_TYPE_23: "entryType23",
  ENTRY_TYPE_52: "entryType52",
  ENTRY_TYPE_61: "entryType61",
  ENTRY_TYPE_62: "entryType62",
  BILL_TYPE_M: "billTypeM",
  BILL_TYPE_R: "billTypeR",
  BILL_TYPE_T: "billTypeT",
  WACM_TITLE: "wacmTitle",
  WACM_BY_SUBMITTED_DATE_TITLE: "wacmBySubmittedDateTitle",
  MESSAGE_FUNCTION: "messageFunction",
  CARGO_CONTROL_NUMBER: "cargoControlNumber",
  DESTINATION_OFFICE_CODE: "destinationOfficeCode",
  ERROR: "error",
  MESSAGE_FUNCTION_ADD: "messageFunctionAdd",
  MESSAGE_FUNCTION_MODIFY: "messageFunctionModify",
  MESSAGE_FUNCTION_CANCEL: "messageFunctionCancel",
  CREATED_DATE: "createdDate",
  GOODS_RELEASED: "goodsReleased",
  DECLARATION_ACCEPTED_AWAITING_ARRIVAL_OF_GOODS: "declarationAcceptedGoods",
  DECLARATION_ACCEPTED_WITH_WARNINGS: "declarationAcceptedWarnings",
  DECLARATION_ACCEPTED_AWAITING_CUSTOMS_PROCESSING: "declarationAcceptedProcessing",
  MESSAGE_CONTENT_REJECTED_WITH_COMMENT: "messageContentRejected",
  MESSAGE_CONTENT_ACCEPTED: "messageContentAccepted",
  GOODS_REQUIRED_FOR_EXAMINATION_REFERRED: "goodsRequiredExamination",
  GOODS_MAY_MOVE_DETAIN_AT_DESTINATION_CFIA: "goodsMayMove",
  ERROR_MESSAGE: "errorMessage",
  AUTHORISED_TO_DELIVER_CSA_SHIPMENT: "authorisedToDeliver",
  ACIAIR_TITLE: "aciAirTitle",
  ACIAIR_BY_SUBMITTED_DATE_TITLE: "aciAirBySubmittedDateTitle",
  CONVEYANCE_REFNO: "conveyanceRefNo",
  CARRIER_CODE: "carrierCode",
  FLIGHT_NO: "flightNo",
  DEPARTURE_PORT: "departurePort",
  ARRIVAL_PORT: "arrivalPort",
  CONVEYANCE_STATUS_1: "conveyanceStatus1",
  CONVEYANCE_STATUS_1048: "conveyanceStatus1048",
  CONVEYANCE_STATUS_1049: "conveyanceStatus1049",
  CONVEYANCE_STATUS_17: "conveyanceStatus17",
  CONVEYANCE_STATUS_200: "conveyanceStatus200",
  CONVEYANCE_STATUS_25: "conveyanceStatus25",
  CONVEYANCE_STATUS_14: "conveyanceStatus14",
  CONVEYANCE_STATUS_28: "conveyanceStatus28",
  CONVEYANCE_STATUS_29: "conveyanceStatus29",
  CONVEYANCE_STATUS_20: "conveyanceStatus20",
  CONVEYANCE_STATUS_21: "conveyanceStatus21",
  CONVEYANCE_STATUS_22: "conveyanceStatus22",
  CONVEYANCE_STATUS_32: "conveyanceStatus32",
  CONVEYANCE_STATUS_33: "conveyanceStatus33",
  AES_TITLE: "aesTitle",
  AES_BY_SUBMITTED_DATE_TITLE: "aesBySubmittedDateTitle",
  SHIPPER_NAME: "shipperName",
  CONSIGNEE_NAME: "consigneeName",
  ENTRY_NUMBER: "entryNumber",
  CBP_ITN_NO: "cbpItnNo",
  ACIOCEAN_TITLE: "aciOceanTitle",
  ACIOCEAN_BY_SUBMITTED_DATE_TITLE: "aciOceanBySubmittedDateTitle",
  ACI_OCEAN_FORM_TYPE: "aciOceanFormType",
  ACI_OCEAN_DOC_TYPE_IMPORT: "aciOceanDocTypeImport",
  ACI_OCEAN_DOC_TYPE_EXPORT: "aciOceanDocTypeExport",
  ACI_OCEAN_DOC_TYPE_EMPTY: "aciOceanDocTypeEmpty",
  ACI_OCEAN_DOC_TYPE_SUPPLEMENTARY: "aciOceanDocTypeSupplementary",
  ACI_OCEAN_CCN: "aciOceanCcn",
  ACI_OCEAN_CUSTOMS_PROCEDURE: "aciOceanCustomsProcedure",
  ACI_OCEAN_CUSTOMS_PROCEDURE_IN_TRANSIT: "aciOceanCustomsProcedureInTransit",
  ACI_OCEAN_CUSTOMS_PROCEDURE_IMPORTED_GOODS: "aciOceanCustomsProcedureImportedGoods",
  ACI_OCEAN_CUSTOMS_PROCEDURE_EXPORTED_GOODS: "aciOceanCustomsProcedureExportedGoods",
  ACI_OCEAN_CUSTOMS_PROCEDURE_FROB: "aciOceanCustomsProcedureFrob",
  ACI_OCEAN_MESSAGE_FUNCTION: "aciOceanMessageFunction",
  ACI_OCEAN_MSG_FUNCTION_ORIGINAL: "aciOceanMsgFunctionOriginal",
  ACI_OCEAN_MSG_FUNCTION_CHANGE: "aciOceanMsgFunctionChange",
  ACI_OCEAN_MSG_FUNCTION_CANCEL: "aciOceanMsgFunctionCancel",
  ACI_OCEAN_CREATED_DATE: "aciOceanCreatedDate"
}

export default DashboardKeys